export const ROUTE_DASHBOARD = '/dashboard';

export const ROUTE_ENCOUNTER = '/encounter';
export const ROUTE_OUTPATIENT = '/outpatient';

export const ICON_ENCOUNTER = 'fas fa-bed fa-fw';
export const ICON_OUTPATIENT = 'fas fa-stethoscope fa-fw';
